var e=e=>`1px solid ${e.palette.isDarkMode?e.palette.neutral[350]:e.palette.neutral[200]}`;export{e as chatBorder};
//# sourceMappingURL=chatStyles.js.map